//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createBillingData, fetchBillingDetails, fetchPlanDetails, updateBilling } from '../../services/billingService';
import { BillingResponse, updateBillingPayload, ApiError, createBillingPayload, BillingState } from './BillingTypes';

// Update job application
export const updateBillingData = createAsyncThunk<BillingResponse, { payload: updateBillingPayload; baseId: number; id: number }, { rejectValue: string }>(
  'base/updateBilling',
  async ({ payload, baseId, id }, { rejectWithValue }) => {
    try {
      const response = await updateBilling(baseId, id, payload);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to update job application');
    }
  }
);

// Fetch job application details
export const fetchBilling = createAsyncThunk<BillingResponse, { baseId: number; }, { rejectValue: string }>(
  'base/fetchBilling',
  async ({ baseId }, { rejectWithValue }) => {
    try {
      const response = await fetchBillingDetails(baseId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

// // create application question set 
// export const createBilling = createAsyncThunk<
//   BillingResponse,
//   { integrationSteps: createBillingPayload[]; userId: number },
//   { rejectValue: string }
// >(
//   'base/createBilling',
//   async ({ integrationSteps, userId }, { rejectWithValue }) => {
//     try {
//       const response = await createBillingData(integrationSteps, userId);
//       return response;
//     } catch (err) {
//       const error = err as ApiError;
//       return rejectWithValue(error.response?.data?.message || 'Failed to create location');
//     }
//   }
// );

// fetch plan
export const fetchPlan = createAsyncThunk<
  BillingResponse,
  { id: number },
  { rejectValue: string }
>(
  'base/fetchPlan',
  async ({ id, currency }, { rejectWithValue }) => {
    try {
      const response = await fetchPlanDetails(id, currency);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);




// Initial state
const initialState: BillingState = {
  updateBillingStatus: 'idle',
  updateBillingError: null,
  updateBillingData: null,

  fetchBillingStatus: 'idle',
  fetchBillingError: null,
  fetchBillingData: null,
  createBillingStatus: 'idle',
  createBillingError: null,
  createBillingData: null,
  fetchPlanStatus: 'idle',
  fetchPlanError: null,
  fetchPlanData: null

};

const BillingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle update job application
    builder
      .addCase(updateBillingData.pending, (state) => {
        state.updateBillingStatus = 'loading';
        state.updateBillingError = null;
      })
      .addCase(updateBillingData.fulfilled, (state, action) => {
        state.updateBillingStatus = 'succeeded';
        state.updateBillingData = action.payload;
        state.updateBillingError = null;
      })
      .addCase(updateBillingData.rejected, (state, action) => {
        state.updateBillingStatus = 'failed';
        state.updateBillingError = action.payload || 'Failed to update job application';
      });

    // Handle fetch job application
    builder
      .addCase(fetchBilling.pending, (state) => {
        state.fetchBillingStatus = 'loading';
        state.fetchBillingError = null;
      })
      .addCase(fetchBilling.fulfilled, (state, action) => {
        state.fetchBillingStatus = 'succeeded';
        state.fetchBillingData = action.payload;
        state.fetchBillingError = null;
      })
      .addCase(fetchBilling.rejected, (state, action) => {
        state.fetchBillingStatus = 'failed';
        state.fetchBillingError = action.payload || 'Failed to fetch job application';
      })
      .addCase(fetchPlan.pending, (state) => {
        state.fetchPlanStatus = 'loading';
        state.fetchPlanError = null;
      })
      .addCase(fetchPlan.fulfilled, (state, action) => {
        state.fetchPlanStatus = 'succeeded';
        state.fetchPlanData = action.payload;
        state.fetchPlanError = null;
      })
      .addCase(fetchPlan.rejected, (state, action) => {
        state.fetchPlanStatus = 'failed';
        state.fetchPlanError = action.payload || 'Failed to fetch job application';
      });
    //   .addCase(createBilling.pending, (state) => {
    //     state.createBillingStatus = 'loading';
    //     state.createBillingError = null;
    //   })
    //   .addCase(createBilling.fulfilled, (state, action) => {
    //     state.createBillingStatus = 'succeeded';
    //     state.createBillingData = action.payload;
    //     state.createBillingError = null;
    //   })
    //   .addCase(createBilling.rejected, (state, action) => {
    //     state.createBillingStatus = 'failed';
    //     state.createBillingError = action.payload || 'Failed to create location';
    //   })
  },
});

export default BillingSlice.reducer;
